import { inject, provide } from 'vue'
import { websiteApi } from '~/api/website'

const SOLUTION_HOME_SIGNED_FILE_LOADER_KEY = Symbol('solutionHomeSignedFileLoader')

/**
 * @description 由方案首页/详情提供当前配置的重新拉取函数，点击签名文件时复用同一份新载荷。
 * @param {() => Promise<unknown>} loader
 * @returns {void}
 */
export function provideSolutionHomeSignedFileLoader(loader) {
  provide(SOLUTION_HOME_SIGNED_FILE_LOADER_KEY, loader)
}

/**
 * @description 读取当前页面提供的方案配置刷新函数；无 provide 时回退到公开 home-content 接口。
 * @returns {() => Promise<unknown>}
 */
export function useSolutionHomeSignedFileLoader() {
  return inject(SOLUTION_HOME_SIGNED_FILE_LOADER_KEY, () => websiteApi.getSolutionHomeContent())
}
